import { listKitchenPrintJobs, type KitchenPrintJob } from '../infra/kitchenPrintJobsRepo';
import { retryKitchenPrintJob } from './printComandaDocuments';

/** Solo queued/retrying: 'failed' agotó sus intentos y espera reintento manual. */
export function selectDueKitchenPrintJobs(jobs: KitchenPrintJob[]): KitchenPrintJob[] {
  return jobs.filter((job) => job.status === 'queued' || job.status === 'retrying');
}

/** Drena la cola durable de comandas: reimprime jobs pendientes; devuelve cuántos salieron. */
export async function drainKitchenPrintJobs(branchId: string): Promise<number> {
  const due = selectDueKitchenPrintJobs(await listKitchenPrintJobs(branchId));
  let printed = 0;
  for (const job of due) {
    try {
      await retryKitchenPrintJob({ branchId, job });
      printed += 1;
    } catch {
      // Queda 'failed'; se reintenta a mano desde Cocina → Más → Impresiones.
    }
  }
  return printed;
}
